<div fxLayout="row" class="flex-lt-md-col">

    <div class="list-container main-container" fxFlex="100%">
        <div class="settings-wrapper">
            <mat-tab-group [selectedIndex]="activeTabIndex">
                <mat-tab label="General">

                    <div class="d-flex-center" style="position: absolute; right: 0; top: 0;">
                        <app-local-diag [setLargeMode]="true"></app-local-diag>
                        <app-theme-selector></app-theme-selector>
                        <app-video-link videoLink="settings"></app-video-link>
                    </div>

                    <div class="d-flex-center">
                        @if (experienceLevel > experienceLevelType.BEGINNER) {
                            <button spinning (click)="onReloadAccountData()" mat-button>
                                <mat-icon class="spinning" matTooltip="{{'account.forceUpdate' | transloco}}">autorenew</mat-icon>
                                {{ 'account.refreshAccount' | transloco }}
                            </button>
                            <button (click)="onForceLogout()" mat-button>
                                <mat-icon matTooltip="{{'account.forceResetLogout' | transloco}}">exit_to_app</mat-icon>
                                {{ 'account.forceReset' | transloco }}
                            </button>
                        }
                    </div>

                    <br/>
                    <br/>
                    <hr/>
                    <br/>

                    <form [formGroup]="formGroupSettings" (ngSubmit)="onSubmit(formGroup.value)" class="form" style="position: relative;">
                        <br/>
                        @if (isFullFeatures || (navGlobal$ | async) == '1') {

                            <div>
                                <mat-label>
                                    <mat-icon>settings_suggest</mat-icon>
                                    <span class="headerIcon">{{ 'general.globalVisibility' | transloco }}</span>
                                </mat-label>
                                <br/>

                                @if (experienceLevel == experienceLevelType.ADVANCED) {
                                    <mat-checkbox style="padding-left: 20px" (change)="onToggleSettings('showExperienceLevel')"
                                                  formControlName="showExperienceLevel">{{ 'general.experienceLevel2' | transloco }}
                                    </mat-checkbox>
                                    <p></p>
                                }

                                <mat-checkbox style="padding-left: 20px" (change)="onToggleSettings('largeLogo')"
                                              formControlName="largeLogo">{{ 'general.largeLogo' | transloco }}
                                </mat-checkbox>
                                <p></p>


                                @if (canShowHelp && (signStudioHelp$ | async) == '1') {
                                    <mat-checkbox style="padding-left: 20px" (change)="onToggleSettings('showHelpEnabled')"
                                                  formControlName="showHelpEnabled">
                                        {{ 'general.showHelpTips2' | transloco }}
                                    </mat-checkbox>
                                    <p></p>

                                    <button type="button" style="position: relative; left: 30px" [class.disabled]="!isResetBlinkingEnabled()" mat-flat-button (click)="resetBlinking($event)">
                                        <mat-icon>
                                            highlight_off
                                        </mat-icon>
                                        reset videos progress
                                    </button>
                                    <br/>
                                    <br/>
                                }

                                @if (isFullFeatures) {
                                    <mat-checkbox style="padding-left: 20px" (change)="onToggleSettings('saveFullFeature')"
                                                  formControlName="saveFullFeature">dev features
                                    </mat-checkbox>
                                    <p></p>
                                }
                            </div>

                            <br/>
                            <br/>


                            @if (isFullFeatures || (navModule$ | async) == '1') {
                                <div>
                                    @if (experienceLevel > experienceLevelType.BEGINNER) {
                                        <mat-label>
                                            <mat-icon>extension</mat-icon>
                                            <span class="headerIcon">{{ 'general.modulesVisibility' | transloco }}</span>
                                        </mat-label>
                                        <br/>
                                        <br/>
                                        <!--                        <mat-checkbox  style="padding-left: 20px; opacity: 0.5;"-->
                                                <!--                                        (change)="onToggleSettings('scheduledEnabled')" formControlName="scheduledEnabled"-->
                                                <!--                                        class="setting-label">{{'general.playlistSched' | transloco}} ({{'general.upgradeEnterprise' | transloco}})</mat-checkbox>-->
                                                <!--                        <p></p>-->

                                        <p></p>
                                    }

                                    @if (experienceLevel > experienceLevelType.BEGINNER) {
                                        <mat-checkbox style="padding-left: 20px" (change)="onToggleSettings('paintEnabled')"
                                                      formControlName="paintEnabled">{{ 'general.painter' | transloco }}
                                        </mat-checkbox>
                                        <p></p>
                                        <mat-checkbox style="padding-left: 20px" (change)="onToggleSettings('catalogEnabled')"
                                                      formControlName="catalogEnabled">{{ 'general.catalogEnabled' | transloco }}
                                        </mat-checkbox>
                                        <p></p>

                                        <mat-checkbox style="padding-left: 20px"
                                                      (change)="onToggleSettings('scheduledEnabled')" formControlName="scheduledEnabled"
                                                      class="setting-label">{{ 'general.scheduler' | transloco }}
                                        </mat-checkbox>
                                        <p></p>
                                    }

                                    @if (experienceLevel == experienceLevelType.ADVANCED) {
                                        <mat-checkbox style="padding-left: 20px" (change)="onToggleSettings('eventsEnabled')"
                                                      formControlName="eventsEnabled">{{ 'general.eventsEnabled' | transloco }}
                                        </mat-checkbox>
                                        <p></p>
                                        <!-- Deprecated
                                                                        <mat-checkbox style="padding-left: 20px" (change)="onToggleSettings('transitionsEnabled')"
                                                                                      formControlName="transitionsEnabled">{{ 'general.animatedTransitions' | transloco }}
                                                                        </mat-checkbox>
                                                                        <p></p>
                                        -->
                                                <!-- Deprecated (will create AudioPlaylist instead)
                                                                                <mat-checkbox style="padding-left: 20px" (change)="onToggleSettings('musicEnabled')"
                                                                                              formControlName="musicEnabled">{{ 'general.musicEnabled' | transloco }}
                                                                                </mat-checkbox>
                                                                                <p></p>
                                                -->

                                        <mat-checkbox style="padding-left: 20px" (change)="onToggleSettings('fasterqEnabled')"
                                                      formControlName="fasterqEnabled">{{ 'general.fasterqEnabled' | transloco }}
                                        </mat-checkbox>
                                        <p></p>
                                    }
                                    @if (experienceLevel > experienceLevelType.BEGINNER) {
                                        <mat-checkbox style="padding-left: 20px"
                                                      (change)="onToggleSettings('dashboardEnabled')" formControlName="dashboardEnabled"
                                                      class="setting-label">{{ 'general.dashboard' | transloco }}
                                        </mat-checkbox>
                                        <p></p>
                                    }
                                    <br/>
                                    <hr/>
                                    <br/>
                                    <br/>
                                </div>
                            }


                            @if (experienceLevel > experienceLevelType.BEGINNER) {
                                <div>
                                    <mat-label>
                                        <mat-icon>settings_suggest</mat-icon>
                                        <span class="headerIcon">{{ 'general.globalSettings' | transloco }}</span>
                                    </mat-label>
                                    <br/>
                                    <br/>
                                    <mat-checkbox style="padding-left: 20px" (change)="onTogglePreference('newsLetter')"
                                                  formControlName="newsLetter">{{ 'general.receiveNewsLetter' | transloco }}
                                    </mat-checkbox>
                                    <p></p>
                                    <mat-checkbox style="padding-left: 20px" (change)="onTogglePreference('autoCheckForUpdates')"
                                                  formControlName="autoCheckForUpdates">{{ 'general.autoCheckForUpdates' | transloco }}
                                    </mat-checkbox>
                                    <p></p>
                                    <!--                    <mat-checkbox style="padding-left: 20px" (change)="onToggleSettings('advancedScheduler')"-->
                                    <!--                                  formControlName="advancedScheduler">-->
                                    <!--                        {{'general.advancedScheduler2' | transloco}}-->
                                    <!--                    </mat-checkbox>-->
                                    <p></p>
                                    <br/>
                                    <br/>
                                </div>
                            }
                        }


                        @if ((experienceLevel > experienceLevelType.BEGINNER) && (isFullFeatures || (navScene$ | async) == '1')) {
                            <div>
                                <mat-label>
                                    <mat-icon>control_camera</mat-icon>
                                    <span class="headerIcon">{{ 'general.sceneControl' | transloco }}</span>
                                </mat-label>
                                <br/>
                                <!--                <mat-checkbox style="padding-left: 20px" (change)="onToggleSettings('saveSceneOnExit')" formControlName="saveSceneOnExit" class="setting-label">{{'general.saveSceneOnExit' | transloco}}</mat-checkbox>-->
                                <!--                <p></p>-->
                                <!--                    <br/>-->
                                <!--                    <mat-checkbox style="padding-left: 20px" (change)="onToggleSettings('sceneCheckeredBackground')"-->
                                <!--                                    formControlName="sceneCheckeredBackground">-->
                                <!--                        {{'general.sceneCheckers' | transloco}}-->
                                <!--                    </mat-checkbox>-->
                                <!--                    <p></p>-->
                                <mat-checkbox style="padding-left: 20px" (change)="onToggleSettings('saveSceneManual')"
                                              formControlName="saveSceneManual">{{ 'general.saveSceneManual' | transloco }}
                                </mat-checkbox>
                                <p></p>
                                <mat-checkbox style="padding-left: 20px" (change)="onToggleSettings('saveSceneTimer')"
                                              formControlName="saveSceneTimer">{{ 'general.saveSceneTimer' | transloco }}
                                </mat-checkbox>
                                <p></p>
                                <!-- showDirections -->
                                <mat-checkbox style="padding-left: 20px" (change)="onToggleSettings('showDirections')"
                                              formControlName="showDirections">{{ 'general.useAutoAlignDragScene' | transloco }}
                                </mat-checkbox>
                                <p></p>
                                <mat-checkbox style="padding-left: 20px" (change)="onToggleSettings('stickersAsEmbedded')"
                                              formControlName="stickersAsEmbedded">{{ 'general.stickersAsShortcuts' | transloco }}
                                </mat-checkbox>
                                <p></p>
                                <div class="offsetLeftSetting">
                                    {{ 'general.sceneFocusOpacity' | transloco }}
                                    <mat-slider discrete disableRipple color="accent"
                                                min="1" max="100"
                                                class="setting-slider">
                                        <input matSliderThumb formControlName="sceneOpacity" (change)="onChangeOpacity($event.target)"/>
                                    </mat-slider>
                                </div>
                                <br/>
                                <div class="offsetLeftSetting">
                                    {{ 'general.sceneGuidelinesOpacity' | transloco }}
                                    <mat-slider discrete disableRipple color="accent"
                                                min="1" max="100"
                                                class="setting-slider">
                                        <input matSliderThumb formControlName="sceneGuidelinesOpacityLevel" (change)="onChangeSceneGuidelinesOpacity($event.target)"/>
                                    </mat-slider>
                                </div>
                                <br/>
                            </div>
                        }


                        @if (experienceLevel > experienceLevelType.BEGINNER) {
                            <div>
                                <mat-label>
                                    <mat-icon>tv</mat-icon>
                                    <span class="headerIcon">{{ 'general.players' | transloco }} ( SignPlayer PWA )</span>
                                </mat-label>
                                <br/>
                                <br/>
                                <mat-checkbox style="padding-left: 20px" (change)="onToggleSettings('restartPlayer')"
                                              formControlName="restartPlayer">{{ 'general.restartPlayer4' | transloco }}
                                </mat-checkbox>
                                <p></p>
                                <mat-checkbox style="padding-left: 20px" (change)="onToggleSettings('restartPlayerOnSceneAssignment')"
                                              formControlName="restartPlayerOnSceneAssignment">{{ 'general.restartPlayerOnSceneAssignment2' | transloco }}
                                </mat-checkbox>
                                <p></p>
                                <br/>
                                <div class="offsetLeftSetting">
                                    {{ 'general.snapshotScale' | transloco }}
                                    <mat-slider discrete disableRipple color="accent"
                                                min="0.1" max="1" step="0.1"
                                                class="setting-slider">
                                        <input matSliderThumb formControlName="snapScale" (change)="onChangeSnapScale($event.target)"/>
                                    </mat-slider>
                                </div>
                                <br/>
                            </div>
                            <br/>
                            <!-- Deprecated
                                                <div>
                                                    <mat-label>
                                                        <mat-icon>dvr</mat-icon>
                                                        <span class="headerIcon">{{ 'general.players' | transloco }} - {{ 'general.playerLegacyOnly' | transloco }} ( SignagePlayer AIR )</span>
                                                    </mat-label>
                                                    <br/>
                                                    <br/>
                                                    <p></p>
                                                    <mat-checkbox style="padding-left: 20px" (change)="onToggleSettings('scriptingMode')"
                                                                  formControlName="scriptingMode">{{ 'general.scriptingMode' | transloco }}
                                                    </mat-checkbox>
                                                    <p></p>

                                                    <br/>
                                                </div>
                                                <br/>
                            -->
                        }
                    </form>
                </mat-tab>

                <mat-tab label="Ai">
                    <div style="display: flex; flex-direction: column;">
                        <div style="display: flex; flex-direction: column; padding-left: 10px">
                            <mat-label>
                                <mat-icon>settings_suggest</mat-icon>
                                <span class="headerIcon">Assistant:</span>
                            </mat-label>

                            <label style="padding-left: 20px"><input type="radio" name="choice" [(ngModel)]="assistant.name" value="openai"  (change)="onAssistantChange()"/> OpenAI</label>
                            <label style="padding-left: 20px"><input type="radio" name="choice" [(ngModel)]="assistant.name" value="gemini"  (change)="onAssistantChange()"/> Gemini</label>
                        </div>
                        <br/>
                        <mat-checkbox [(ngModel)]="assistant.autoHide" (change)="onAssistantChange()">Auto hide when finished
                        </mat-checkbox>
                        <mat-checkbox [(ngModel)]="assistant.showThinking" (change)="onAssistantChange()">show thinking process
                        </mat-checkbox>
                    </div>
                </mat-tab>

            </mat-tab-group>

        </div>
    </div>
    @if (experienceLevel > experienceLevelType.BEGINNER) {
        <div class="props-container flex-lt-md-100" fxFlex="285px">
            <div>
                <ng-template #forminfo>
                    <div class="container">
                        {{ post }}
                        <h1>aaa</h1>
                    </div>
                </ng-template>
            </div>
            <mat-tab-group [@.disabled]="true" tabGroupDrag class="mini-tab" style="user-select: text">
                <mat-tab label="{{'general.accountInfo' | transloco}}">
                    <br/>
                    <br/>

                    <ul class="accountDetails">
                        <li>email: {{ this.user.email }}</li>
                        <li>access: {{ isAccessDenied(this.user) === false ? 'enabled' : 'disabled' }}</li>
                        <li>reseller id: {{ this.user.resellerId }}</li>
                        <li>business id: {{ this.user.businessId }}</li>
                        <li>payer id: {{ this.user?.payerId }}</li>
                        <li>email: {{ this.user.email }}</li>
                        <li>user name: {{ this.user.username }}</li>
                        <li>business name: {{ this.user?.businessName }}</li>
                        <li>business domain: {{ this.user?.businessDomain }}</li>
                        <li>ip: {{ this.user?.ip }}</li>
                        <li>user status: {{ this.user.accountStatus }}</li>
                        <li>reseller status: {{ this.user?.accountStatusReseller }}</li>
                        <li>offline mode: {{ this.appSettings.workOffline }}</li>
                        <li>protocol: {{ this.appSettings.protocol }}</li>
                        <li>private server: {{ this.privateServer }}</li>
                        <li>LDAP: {{ this.ldapServer }}</li>
                    </ul>
                    <br/>
                    <br/>
                    <br/>
                    <mat-divider></mat-divider>
                </mat-tab>
                <mat-tab label="{{'general.development' | transloco}}">
                    <div (click)="openLink()" class="linkable">
                        <mat-divider></mat-divider>
                        <br/>
                        <div matTooltip="Angular ROCKS!!!" fxLayout="row" fxLayoutAlign="center center">
                            <div style="background-color: white; width: 57px; height: 70px; border: red 2px solid">
                                <fa-icon size="1x" class="angular" [icon]="faAngular"></fa-icon>
                            </div>
                        </div>
                    </div>
                    <br/>
                    <ul class="accountDetails">
                        <li>runtime: Angular.io</li>
                        <li>ng version: {{ version }}</li>
                        <li>ng build tooling: ng-cli</li>
                        <li>mediaCLOUD: {{ cloudVersion }}</li>
                        <li>SignStudio version: {{ appVersion }}</li>
                        <li>license: GNU+ modified</li>
                        <li>development mode: {{ devMode }}</li>
                        <li>country of origin: USA</li>
                    </ul>
                    <mat-divider></mat-divider>
                    <button style="width: 100%; opacity: 0.01; margin-top: 300px" (click)="testError()" mat-flat-button>
                        <mat-icon>bug_report</mat-icon>
                        test dev
                    </button>

                </mat-tab>
                <mat-tab label="{{'general.os' | transloco}}">
                    <br/>
                    <br/>
                    <ul class="accountDetails">
                        <li>family: {{ this.os?.family }}</li>
                        <li>type: {{ this.os?.name1 }}</li>
                        <li>version: {{ this.os?.version }}</li>
                        <li>architecture id: {{ os?.info?.os?.architecture }}</li>
                        <li>os version: {{ os?.info?.os?.version }}</li>
                        <li>layout: {{ os?.info?.layout }}</li>
                        <li>details: {{ os?.uaSting }}</li>
                    </ul>
                    <br/>
                    <br/>
                    <br/>
                    <mat-divider></mat-divider>
                </mat-tab>
            </mat-tab-group>
        </div>
    }
</div>


<!--<p class="actions">-->
<!--    <button mat-raised-button color="accent" routerLink="/overview">-->
<!--        <mat-icon>keyboard_arrow_left</mat-icon>-->
<!--        back</button>-->
<!--    <button *ngIf="!enterpriseMode" mat-raised-button color="warn" (click)="openSearchFormDialog()">-->
<!--        <mat-icon>cloud_upload</mat-icon>-->
<!--        enterprise upgrade-->
<!--    </button>-->
<!--    <button *ngIf="enterpriseMode" mat-raised-button color="primary" (click)="createUser()">-->
<!--        <mat-icon>speaker_notes</mat-icon>-->
<!--        enterprise report-->
<!--    </button>-->
<!--    <button *ngIf="enterpriseMode" mat-raised-button color="primary" (click)="deleteUser()">-->
<!--        <mat-icon>report</mat-icon>-->
<!--        enterprise termination-->
<!--    </button>-->
<!--</p>-->


<!-- test code for Alon -->
<!--                    <input type="button" value="callback" onClick="my1('value1')" />-->
<!--                    <script type="text/javascript">-->
<!--                        function testEcho(v2) {-->
<!--                            alert(v2);-->
<!--                            return "ggg";-->
<!--                        }-->
<!--                        function my1(v2) {-->
<!--                            Android.fromJS("123");-->
<!--                        }-->
<!--                    </script>-->
<!--                    <form [formGroup]="formGroup" (ngSubmit)="onSubmit(formGroup.value)" class="form">-->


<!--                <div class="form-element">-->
<!--                    <button mat-raised-button color="primary" (submit)="onSubmit($event)" type="submit" class="button" [disabled]="!formGroup.valid">Save user settings</button>-->
<!--                </div>-->

<!--                        <mat-form-field class="form-element">-->
<!--                            <input matInput placeholder="{{'placeholder.email' | transloco}}" formControlName="email">-->
<!--                            <mat-error *ngIf="!formGroup.controls['email'].valid && formGroup.controls['email'].touched">-->
<!--                                {{ getErrorEmail() }}-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->
<!--                        <mat-form-field class="form-element">-->
<!--                            <input (keyup)="updateName($event)" matInput placeholder="{{'placeholder.accountName' | transloco}}" formControlName="name">-->
<!--                            <mat-error *ngIf="!name.valid && name.touched">-->
<!--                                {{ titleAlert }}-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->
<!--                        <mat-form-field class="form-element">-->
<!--                            <textarea matInput placeholder="{{'placeholder.accountDescription' | transloco}}" matTextareaAutosize matAutosizeMinRows="2" matAutosizeMaxRows="5" formControlName="description"></textarea>-->
<!--                            <mat-error *ngIf="!formGroup.controls['description'].valid && formGroup.controls['description'].touched">-->
<!--                                must be 5 to 50 char-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->
<!--                        <mat-form-field class="form-element">-->
<!--                            <input matInput placeholder="{{'placeholder.password' | transloco}}" type="password" formControlName="password">-->
<!--                            <mat-hint>8 characters, uppercase and number</mat-hint>-->
<!--                            <mat-error *ngIf="!formGroup.controls['password'].valid && formGroup.controls['password'].touched">-->
<!--                                {{ getErrorPassword() }}-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->

<!--                        <mat-form-field class="form-element">-->
<!--                            <input matInput placeholder="{{'placeholder.datePass' | transloco}}" [matDatepicker]="picker2" formControlName="createTimeEnd">-->
<!--                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>-->
<!--                            &lt;!&ndash;                    <mat-datepicker [touchUi]="touchUi" #picker2></mat-datepicker>&ndash;&gt;-->
<!--                            <mat-datepicker  #picker2></mat-datepicker>-->
<!--                        </mat-form-field>-->

<!--                        <mat-form-field class="form-element">-->
<!--                            <mat-label>-->
<!--                                {{'general.screenNotification' | transloco}}-->
<!--                            </mat-label>-->
<!--                            <mat-select>-->
<!--                                <mat-option *ngFor="let item of screensState" [value]="item.value">-->
<!--                                    {{item.viewValue}}-->
<!--                                </mat-option>-->
<!--                            </mat-select>-->
<!--                        </mat-form-field>-->
<!--                        <div class="form-element">-->
<!--                            <mat-checkbox formControlName="validate" value="1">{{'general.requirePassChange' | transloco}}</mat-checkbox>-->
<!--                        </div>-->
<!--                        <mat-divider></mat-divider>-->
<!--                        <div class="pull-right" style="position: relative; top: -15px; padding: 30px">-->
<!--                            <span style="margin-right: 30px" class="pull-right">{{'general.youreMoji2' | transloco}}</span>-->
<!--                            <br/>-->
<!--                            <canvas width="140" height="140" [attr.data-jdenticon-value]="this.user.name"></canvas>-->
<!--                        </div>-->

<!--                        <div fxLayout="row" fxLayout.xs="column" class="form-element">-->
<!--                            <div fxFlex="120px" fxFlex.xs>-->
<!--                                <img class="avatar" [src]="avatarSrc || model.avatarURL">-->
<!--                            </div>-->
<!--                            <div fxFlex="24px" fxFlex.xs="10px"></div>-->
<!--                            <div class="actions" fxFlex>-->
<!--                                <input #avatarInput class="hidden" type="file" accept="image/png, image/jpeg" (change)="selectAvatar($event.target.files)">-->
<!--                                <button mat-raised-button color="primary" (click)="avatarInput.click()">{{'general.select' | transloco}}</button>-->
<!--                                <button mat-raised-button color="accent" (click)="updateAvatar()" [disabled]="!avatarFile || avatarInvalid || uploaded"-->
<!--                                        [matTooltip]="uploaded ? ('general.avatarUpdated' | transloco) : avatarFile ? ('general.avatarClick' | transloco) : ('general.noFile' | transloco)"-->
<!--                                        matTooltipPosition="right">-->
<!--                                    {{uploaded ? 'Updated' : 'Update'}}-->
<!--                                </button>-->
<!--                                <div class="error-wrapper">-->
<!--                                    <mat-error>-->
<!--                                        <ng-template [ngIf]="avatarTooSmall">-->
<!--                                            {{'general.tooLarge' | transloco}}-->
<!--                                        </ng-template>-->
<!--                                        <ng-template [ngIf]="avatarTooLarge">-->
<!--                                            {{'general.tooSmall' | transloco}}-->
<!--                                        </ng-template>-->
<!--                                    </mat-error>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->

<!--                <div class="form-element">-->
<!--                    <button mat-raised-button color="primary" (submit)="onSubmit($event)" type="submit" class="button" [disabled]="!formGroup.valid">Save user settings</button>-->
<!--                </div>-->

<!--                <div class="container" *ngIf="!post; else forminfo" novalidate>-->
<!--                    <form [formGroup]="formGroup" class="form">-->
<!--                        <mat-form-field class="form-element">-->
<!--                            <label>-->
<!--                                <input matInput placeholder="{{'placeholder.email' | transloco}}" formControlName="email">-->
<!--                            </label>-->
<!--                            <mat-error *ngIf="!formGroup.controls['email'].valid && formGroup.controls['email'].touched">-->
<!--                                {{ getErrorEmail() }}-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->
<!--                        <mat-form-field class="form-element">-->
<!--                            <label>-->
<!--                                <input (keyup)="updateName($event)" matInput placeholder="{{'placeholder.accountName' | transloco}}" formControlName="name">-->
<!--                            </label>-->
<!--                            <mat-error *ngIf="!name.valid && name.touched">-->
<!--                                {{ titleAlert }}-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->
<!--                        <mat-form-field class="form-element">-->
<!--                            <label>-->
<!--                                <textarea matInput placeholder="{{'placeholder.accountDescription' | transloco}}" [matTextareaAutosize]="true" [matAutosizeMinRows]="2" [matAutosizeMaxRows]="5" formControlName="description"></textarea>-->
<!--                            </label>-->
<!--                            <mat-error *ngIf="!formGroup.controls['description'].valid && formGroup.controls['description'].touched">-->
<!--                                must be 5 to 50 char-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->
<!--                        <mat-form-field class="form-element">-->
<!--                            <input matInput placeholder="{{'placeholder.password' | transloco}}" type="password" formControlName="password">-->
<!--                            <mat-hint>8 characters, uppercase and number</mat-hint>-->
<!--                            <mat-error *ngIf="!formGroup.controls['password'].valid && formGroup.controls['password'].touched">-->
<!--                                {{ getErrorPassword() }}-->
<!--                            </mat-error>-->
<!--                        </mat-form-field>-->
<!--                        <mat-form-field class="form-element">-->
<!--                            <input matInput placeholder="{{'placeholder.datePass' | transloco}}" [matDatepicker]="picker2" formControlName="createTimeEnd">-->
<!--                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>-->
<!--                            &lt;!&ndash;                    <mat-datepicker [touchUi]="touchUi" #picker2></mat-datepicker>&ndash;&gt;-->
<!--                            <mat-datepicker #picker2></mat-datepicker>-->
<!--                        </mat-form-field>-->
<!--                        <mat-form-field class="form-element">-->
<!--                            <mat-label>-->
<!--                                {{'general.screenNotification' | transloco}}-->
<!--                            </mat-label>-->
<!--                            <mat-select>-->
<!--                                <mat-option *ngFor="let item of screensState" [value]="item.value">-->
<!--                                    {{item['viewValue']}}-->
<!--                                </mat-option>-->
<!--                            </mat-select>-->
<!--                        </mat-form-field>-->
<!--                        <div class="form-element">-->
<!--                            <mat-checkbox formControlName="validate" value="1">{{'general.requirePassChange' | transloco}}</mat-checkbox>-->
<!--                        </div>-->
<!--                        <mat-divider></mat-divider>-->
<!--                    </form>-->
<!--                </div>-->
